import $ from 'jquery';
import moment from 'moment';


const formatTime_hour = function(hour, min, sec) {
    return `${hour>=10?hour:'0'+hour}:${min>=10?min:'0'+min}:${sec>=10?sec:'0'+sec}`
};

const formatTime = function(min, sec) {
    return `${min>=10?min:'0'+min}:${sec>=10?sec:'0'+sec}`
};

const renderTime = function(duration, ele) {
    if(duration.hours() < 1){
        ele.text(formatTime(
            duration.minutes(),
            duration.seconds()
        ));
    }else{
        ele.text(formatTime_hour(
            duration.hours(),
            duration.minutes(),
            duration.seconds()
        ));
    }
};

$(document)
    .ready(function() {
        const $timer = $('.timer');
        
        if(!$timer.length) return;
        
        let now = moment($timer.data('now'))
        let dist = moment($timer.data('time'))
        let duration = moment.duration( dist.diff(now) )

        renderTime(duration, $timer);

        let countDown = setInterval(() => {
            duration.subtract(1, 'seconds');
            renderTime(duration, $timer);
            if(duration.asSeconds() <= 0){
                clearInterval(countDown);
                location.reload(true);
            }
        }, 1000);
    })
    .on("visibilitychange", function () {
        document.visibilityState == 'visible' && location.reload();
    });
